export default __webpack_public_path__ + "static/media/user_icon.bae243e8.svg";